import { SuretyAccountId, SuretyIndemnityAgreementId, UploadedFile } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";

export const useGetAccountIndemnityAgreementFile = (
	accountId: SuretyAccountId,
	indemnityAgreementId: SuretyIndemnityAgreementId,
) => {
	const { get } = useRequest();

	const indemnityAgreement = useQuery({
		queryKey: ["accounts", accountId, "indemnity-agreements", indemnityAgreementId, "file"],
		queryFn: async () =>
			await get<UploadedFile>(
				`/v2/surety/accounts/${accountId}/indemnity-agreements/${indemnityAgreementId}/file`,
			),
		refetchOnReconnect: false,
		refetchOnMount: false,
	});

	return {
		indemnityAgreementFile: indemnityAgreement.data,
		indemnityAgreementFileError: indemnityAgreement.error,
		indemnityAgreementFileLoading: indemnityAgreement.isLoading,
	};
};
